import SimpleCrud from "./SimpleCrud";

const EMPTY = { full_name: "", phone: "", phone_secondary: "", email: "", cdl_class: "A", endorsements: "", years_experience: 0, status: "active", home_city: "", notes: "" };
const FIELDS = [
  { key: "full_name", label: "Full Name" },
  { key: "phone", label: "Primary Phone" },
  { key: "phone_secondary", label: "Secondary Phone" },
  { key: "email", label: "Email" },
  { key: "cdl_class", label: "CDL Class (A only)" },
  { key: "endorsements", label: "Endorsements" },
  { key: "years_experience", label: "Years Exp", type: "number" },
  { key: "status", label: "Status" },
  { key: "home_city", label: "Home City" },
  { key: "notes", label: "Notes", textarea: true },
];

export default function Drivers() {
  return <SimpleCrud title="Drivers" endpoint="drivers" testid="drivers-admin" empty={EMPTY} fields={FIELDS} />;
}
